import axios from './api';
import { getUrl } from './utils';

const endPoint = getUrl('api') + '/api/v2/cemosa';

const getCemosaUpdates = (project) =>
  axios.get(endPoint.concat(`/update/${project}`), {});

export { getCemosaUpdates };
